import { render } from "./FormTitle.vue?vue&type=template&id=41cefd9c&scoped=true&ts=true"
import script from "./FormTitle.vue?vue&type=script&lang=ts"
export * from "./FormTitle.vue?vue&type=script&lang=ts"

import "./FormTitle.vue?vue&type=style&index=0&id=41cefd9c&scoped=true&lang=scss"

import exportComponent from "/Users/bekircankaya/Documents/GitHub/kurban-vekalet-frontend-eski-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cefd9c"]])

export default __exports__